import { Component, inject, signal } from '@angular/core';

import { AuthService } from '~features/auth/auth.service';
import { BRAND } from '~global-constants/brand';

@Component({
  selector: 'app-confirmation-banner',
  standalone: true,
  templateUrl: './confirmation-banner.component.html',
})
export class ConfirmationBannerComponent {
  readonly brand = BRAND;
  private authService = inject(AuthService);

  showBanner = this.authService.showConfirmationBanner;
  isDismissed = signal(false);
  isResending = signal(false);
  resendSuccess = signal(false);
  resendError = signal(false);

  get shouldShow() {
    return this.showBanner() && !this.isDismissed();
  }

  dismiss() {
    this.isDismissed.set(true);
  }

  async resendConfirmationEmail() {
    if (this.isResending()) return;

    this.isResending.set(true);
    this.resendError.set(false);
    this.resendSuccess.set(false);

    try {
      await this.authService.resendConfirmationEmail();
      this.resendSuccess.set(true);

      // Hide success message after 3 seconds
      setTimeout(() => {
        this.resendSuccess.set(false);
      }, 3000);
    } catch (error) {
      console.error('Error resending confirmation email:', error);
      this.resendError.set(true);

      // Hide error message after 5 seconds
      setTimeout(() => {
        this.resendError.set(false);
      }, 5000);
    } finally {
      this.isResending.set(false);
    }
  }
}
